import FeaturesTable from '../components/Tables/FeaturesTable';
import PlaceHolderTable from '../components/Tables/PlaceHolderTable';
import React, { useState, useEffect } from 'react';
import { TableConstants, TableType } from '../TableConstants';
import Button from 'react-bootstrap/Button';
import { Link } from 'react-router-dom';
import { GetAllFeatureFlags, GetAllConfigurations} from "../api/Api";
import { cleanAndSetFeatureFlags } from "../Extensions/CleanAndSetFeatureFlags";
import { toTableFeatureFlag } from "../Extensions/ToTableFeatureFlag";
import { toTableConfigurations } from '../Extensions/ToTableConfigurations';

function Main() {

    const [isFetchingFeatures, setIsFetchingFeatures] = useState(true);
    const [isFetchingConfigurations, setIsFetchingConfigurations] = useState(true);
    const [featureFlags, setFeatureFlags] = useState([]);
    const [configurations, setConfigurations] = useState([]);

    useEffect(() => {
        GetAllFeatureFlags().then(
            (res) => {
                let flagData = cleanAndSetFeatureFlags(res.data);
                let tableFlags = toTableFeatureFlag(flagData);
                setFeatureFlags(tableFlags);
                setIsFetchingFeatures(false);
            });

        GetAllConfigurations().then(
            (res) => {
                let tableConfig = toTableConfigurations(res.data)
                setConfigurations(tableConfig);
                setIsFetchingConfigurations(false);
            }
        )
    }, []);

    return <section style={{ margin: "20px" }}>
        {isFetchingFeatures ? <PlaceHolderTable /> :
            <React.Fragment>
                <Link to={'featureflag/add'}><Button variant='secondary'>Add Feature Flag</Button></Link>
                <FeaturesTable cols={TableConstants(featureFlags)} data={featureFlags} tableType={TableType.FeatureFlag} isDark bordered striped hoverable />
            </React.Fragment>
        }
        
        {isFetchingConfigurations ? <PlaceHolderTable /> : 
        <React.Fragment>
            <Link to={'configuration/add'}><Button variant='secondary'>Add Configuration</Button></Link>
            <FeaturesTable cols={TableConstants(configurations)} data={configurations} tableType={TableType.Configuration} isDark bordered striped hoverable />
        </React.Fragment>
        }
    </section>
}

export default Main;